import React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { CHAPTER_COUNTY, getActiveChapterSlug } from "../../lib/chapters"
import { PRAYER_REQUEST_HASH, TESTIMONY_HASH } from "../../lib/prayerTestimony"
import LandingPrayerRequestModal from "./LandingPrayerRequestModal"
import LandingTestimonyModal from "./LandingTestimonyModal"

const LandingPrayerTestimonyModals: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const hash = decodeURIComponent(location.hash.replace(/^#/, ""))
  const slug = getActiveChapterSlug(location.pathname)
  const defaultCounty = slug ? CHAPTER_COUNTY[slug] : undefined

  const close = () => {
    navigate({ pathname: location.pathname, search: location.search, hash: "" }, { replace: true })
  }

  return (
    <>
      <LandingPrayerRequestModal
        open={hash === PRAYER_REQUEST_HASH}
        onClose={close}
        defaultCounty={defaultCounty}
      />
      <LandingTestimonyModal
        open={hash === TESTIMONY_HASH}
        onClose={close}
        defaultCounty={defaultCounty}
      />
    </>
  )
}

export default LandingPrayerTestimonyModals
